// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 67) return "css/academics-fa4d6a46.css";
	if (chunkId === 936) return "css/fused-d8f7b2e7.css";
	if (chunkId === 740) return "css/print-50609a88.css";
	if (chunkId === 964) return "css/style_guide-00840f91.css";
	if (chunkId === 165) return "css/zeit_jobs-6567a008.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"11":"58fb4d38","179":"58fb4d38","349":"333d64f0","847":"ccd24d5a","922":"3cac9297","931":"e539f035"}[chunkId] + ".css";
};